import React, { useState } from "react";
import {
  Button,
  Upload,
  Table,
  Modal,
  Spin,
  Select,
  Empty,
  Card,
  message,
} from "antd";
import { UploadOutlined, FileOutlined } from "@ant-design/icons";
import useAuth from "../../../hooks/useAuth";
import useFirmFileService from "../../../services/useFirmFileService";
import Endpoints from "../../../api/endpoints";
import useFirmService from "../../../services/useFirmService";

const { Option } = Select;

const FirmDocuments = () => {
  const [fileList, setFileList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [documentType, setDocumentType] = useState("");
  const [selectedEndpoint, setSelectedEndpoint] = useState("");
  const { useAddFirmDocuments } = useFirmFileService();
  const { mutateAsync: addFirmDocument, isPending: isAddDocumentLoading } =
    useAddFirmDocuments();
  const { useGetFirm } = useFirmService();
  const { data: firm, isLoading: isFirmLoading } = useGetFirm();

  const { signatureUrl, taxCertificateUrl, tradeRegistryUrl } = firm?.data;

  const documentTypes = [
    {
      label: "Vergi Levhası",
      value: Endpoints.addTaxCertificate,
      url: taxCertificateUrl,
    },
    {
      label: "Ticaret Sicil Belgesi",
      value: Endpoints.addTradeRegistry,
      url: tradeRegistryUrl,
    },
    {
      label: "İmza Sürküleri",
      value: Endpoints.addSignature,
      url: signatureUrl,
    },
  ];

  const handlePreview = (fileUrl) => {
    const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(fileUrl);

    if (isImage) {
      setPreviewUrl(fileUrl);
      setIsModalOpen(true);
    } else {
      window.open(fileUrl, "_blank");
    }
  };

  const handleUpload = async () => {
    if (!fileList[0] || !selectedEndpoint) {
      message.error("Lütfen bir dosya ve doküman tipi seçin");
      return;
    }

    const formData = new FormData();
    const file = fileList[0].originFileObj || fileList[0];
    formData.append("file", file);
    console.log("before upload the endpoint is", selectedEndpoint);

    try {
      await addFirmDocument({
        formData: formData,
        endpointUrl: selectedEndpoint,
      });
      setFileList([]);
      setDocumentType("");
      setSelectedEndpoint("");
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  const handleTypeChange = (value, option) => {
    setDocumentType(option.label);
    setSelectedEndpoint(value);
    console.log("selected endpoint is", value);
  };

  const columns = [
    {
      title: "Doküman Tipi",
      dataIndex: "type",
      key: "type",
      width: "30%",
    },
    {
      title: "Durum",
      dataIndex: "status",
      key: "status",
      width: "40%",
      render: (_, record) => (
        <span style={{ color: record.url ? "#52c41a" : "#ff4d4f" }}>
          {record.url ? "Yüklenmiş" : "Yüklenmemiş"}
        </span>
      ),
    },
    {
      title: "İşlemler",
      key: "actions",
      width: "30%",
      render: (_, record) =>
        record.url && (
          <Button type="link" onClick={() => handlePreview(record.url)}>
            Görüntüle
          </Button>
        ),
    },
  ];

  const currentDocuments = documentTypes.map((doc) => ({
    key: doc.value,
    type: doc.label,
    url: doc.url,
  }));

  const uploadProps = {
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList,
    onRemove: () => {
      setFileList([]);
    },
    maxCount: 1,
  };

  if (isAddDocumentLoading || isFirmLoading) {
    return (
      <div style={styles.loadingContainer}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <Card title="Firma Dokümanları" style={styles.card}>
        <div style={styles.uploadSection}>
          <Select
            placeholder="Doküman Tipini Seçin"
            onChange={handleTypeChange}
            style={styles.select}
            value={documentType || undefined}>
            {documentTypes.map((type) => (
              <Option key={type.value} value={type.value}>
                {type.label}
              </Option>
            ))}
          </Select>

          <Upload {...uploadProps}>
            <Button icon={<UploadOutlined />}>Dosya Seç</Button>
          </Upload>

          <Button
            type="primary"
            onClick={handleUpload}
            disabled={fileList.length === 0 || !selectedEndpoint}
            style={styles.uploadButton}>
            Yükle
          </Button>
        </div>

        <div style={styles.tableSection}>
          <Table
            columns={columns}
            dataSource={currentDocuments}
            pagination={false}
          />
        </div>
      </Card>

      <Modal
        open={isModalOpen}
        footer={null}
        onCancel={() => setIsModalOpen(false)}
        width={800}>
        {previewUrl && (
          <img src={previewUrl} style={{ width: "100%" }} alt="Preview" />
        )}
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    padding: "24px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  card: {
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  uploadSection: {
    marginBottom: "24px",
    display: "flex",
    gap: "16px",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  select: {
    width: "250px",
  },
  uploadButton: {
    marginLeft: "auto",
  },
  tableSection: {
    backgroundColor: "#fafafa",
    padding: "16px",
    borderRadius: "8px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
};

export default FirmDocuments;
